export default __webpack_public_path__ + "static/media/offshore.0beffee7.svg";